import React, { useEffect, useState } from 'react'
import { fetchDeveloperByRoleOrSkill } from '../../redux/action/homeAction'
import { useDispatch, useSelector } from 'react-redux'
import DeveloperCard from '../common/DeveloperCard'
import { DoubleStar } from "../../constants/ImagePaths"
import Image from '../../components/general/Image'
import DashedChips from '../../components/common/DashedChips'
import OverlayedDeveloperCard from '../common/OverlayedDeveloperCard'
import RegistrationCardForm from '../common/RegistrationCardForm'
import SuccessModal from '../findJobs/SuccessModal'
import { ArrowUpRight } from '../../components/common/Icons'
import { setShowSuccessModal } from '../../redux/slice/commonSlice'
import { useNavigate } from 'react-router-dom'


const Developer = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { developerListByRoleSkills } = useSelector(state => state.home);
    const [showRegisterForm, setShowRegisterForm] = useState(false);
    const { hire_registration: { stepTwoData: { skills } } } = useSelector(state => state.common);
    const { hire_registration: { stepOneData: { specialization } } } = useSelector(state => state.common);
    const { showSuccessModal } = useSelector(state => state.common);

    useEffect(() => {
        dispatch(fetchDeveloperByRoleOrSkill(`skills=${skills?.map(p => p.value)?.toString()}&specialization__id=${specialization}&priority_algorithm=1`))
        // eslint-disable-next-line
    }, [])

    const handleSuccessModalClose = () => {
        dispatch(setShowSuccessModal(false));
        
        setTimeout(() => {
            navigate('/');
        }, 1000);
    }

    return (
        <>
            <div className='text-white !py-[30px] !pb-[100px] lg:!pb-[100px] lg:!px-[50px]'>
                <div className="">
                    <div className="">
                        <h3 className="text-[30px] lg:text-[40px] font-bold flex justify-center text-center">
                            <span>Register to access ready-to-hire devs</span>
                            <Image src={DoubleStar} alt="double-star" className="w-[40px] h-[40px] hidden lg:block ml-[10px]" />
                        </h3>
                        <p className='text-center'>Tech stack <span className='text-primary-color'> (can be changed later)</span></p>
                        
                        <div className='flex justify-center gap-[10px] flex-wrap items-center my-[20px]'>
                            {
                                skills.map((skill, index) => (
                                    <DashedChips keyName={index} text={skill.label} />
                                ))
                            }
                        </div>
                    </div>
                </div>
                <div className="hireDeveloperCon registerDeveloper">
                    <div className="remoteDeveloper">
                        <div className="developers">
                            <div className="flex flex-col gap-[20px] md:grid md:grid-cols-2 lg:grid-cols-3">
                                <DeveloperCard
                                    developers={developerListByRoleSkills}
                                />
                                {
                                    !showRegisterForm && (
                                        <OverlayedDeveloperCard onClick={() => setShowRegisterForm(true)} developer={developerListByRoleSkills[Math.floor(Math.random() * 7)]} />
                                    )
                                }
                                {
                                    showRegisterForm && (
                                        <RegistrationCardForm name="Unknown (From Registration Card)" />
                                    )
                                }
                            </div>
                            {/* <div className="text-center">
                                <a href="void:(0)" className="btn btn-primary">Register to view more <ArrowUpRight className="w-4 h-4" /></a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div >
            <SuccessModal show={showSuccessModal} onClose={handleSuccessModalClose} />
        </>

    )
}

export default Developer